import { ORDERS_BULK_PICKUP_ENABLED } from 'App/featuresFlags';
import { useGetTags } from 'domains/Auth/hooks';

export function useIsOrdersBulkPickupEnabled(): boolean {
  const tags = useGetTags() ?? [];
  return tags.includes(ORDERS_BULK_PICKUP_ENABLED);
}
